import {
    EditCartItemProps,
    LumpsumValidationType
} from '../types'
import {
    Box,
    Grid,
    Theme,
    useTheme
} from '@mui/material'
// import {
// CustomeBlueDropDown,
// CustomeModalButton,
// CustomeNumberInput
// } from '../../../lib/formik/NewFormInputs'
import { Formik, FormikValues, useFormik } from 'formik';
import { LumpsumScheme, SipScheme } from './Scheme';
import { MpowerValidationType } from '../../investorOverview/types';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { formatCurrency } from '../../../utils/utilityFunctions';
import { useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput } from '../../investorOverview/transcation/FromInput';
import { color } from 'chart.js/helpers';

type Props = {
    data: EditCartItemProps,
    validation: MpowerValidationType,
    currentTransactionType: string,
    folio: string[]
    schemeLoading: boolean
    scheme: InvestmentFundType
}

function Lumpsum({ data, validation, currentTransactionType, folio, schemeLoading, scheme }: Props) {
    const theme = useTheme()

    const { onSave, lumpsumAmount, onCancel, isLoading, activeCategory, folioNumber } = data
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);

    // sheme
    const schemeValidation = LumpsumScheme({ folioNumber, lumpsumAmount, activeCategory, scheme, currencySymbol })

    // handleSubmit
    function handleSubmitBtn(formValues: FormikValues) {

        const isNewFolioSelected = `${formValues?.folios ?? ""}`?.toLowerCase() === "new folio"

        onSave(
            data.id,
            currentTransactionType,
            {
                amount: formValues.lumpsumAmount,
                ...(activeCategory === "New Purchase" ? { folio: formValues.folios } : {}),
                trType: isNewFolioSelected ? "FRESH" : "ADDITIONAL"
            })
    }

    const filterValidation = scheme?.validations?.filter((item) => item?.transactionType === 'SUB')?.[0]

    return (
        <Formik
            initialValues={{
                lumpsumAmount: lumpsumAmount || '0',
                ...(activeCategory === "New Purchase" ? { folios: folioNumber } : {})
            }}
            onSubmit={handleSubmitBtn}
            validationSchema={schemeValidation}
            enableReinitialize
        >
            {(formik) => {
                const isNewFolioSelected = `${formik.values?.folios ?? ""}`?.toLowerCase() === "new folio"

                const isAdditionalPurchase = `${activeCategory ?? ""}`.toLowerCase() === "additional purchase"

                let minLumpsumAmount = filterValidation?.minimumInstallmentAmount ?? 0

                if (isAdditionalPurchase || (!isAdditionalPurchase && !isNewFolioSelected)) {
                    minLumpsumAmount = filterValidation?.addtionalMinimumPurchaseAmpunt ?? 0;
                }

                return (
                    <Box component={'form'} onSubmit={formik.handleSubmit}>
                        <Grid
                            container
                            spacing={2}
                        >
                            <Grid
                                item
                                xs={6}
                                sx={{ paddingBottom: "20px" }}
                            >
                                <CustomeNumberInput
                                    disable={isLoading}
                                    isLoading={schemeLoading}
                                    textType="number"
                                    label='Lumpsum Amount'
                                    name={`lumpsumAmount`}
                                    minlabel={`Min:${formatCurrency({ value: (Number(minLumpsumAmount ?? 0)), locale, currencyCode })}`}
                                    removeIcons={true}
                                    warningText={'amount'}
                                />
                            </Grid>
                            {activeCategory === "New Purchase" &&
                                <Grid
                                    item
                                    xs={6}
                                    sx={{ paddingBottom: "20px" }}
                                >
                                    <CustomeBlueDropDown
                                        // disabled={isLoading}
                                        disabled
                                        isLoading={schemeLoading}
                                        label='Select Folio'
                                        name={'folios'}
                                        list={folio?.map((item: string) => ({ label: item, value: item }))}
                                    />
                                </Grid>
                            }
                            <Grid
                                item
                                container
                                xs={12}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderTop: `0.5px solid ${theme.palette.text.secondary}B2`
                                }}
                            >
                                <Grid
                                    item
                                    container
                                    xs={10}
                                    sx={{
                                        columnGap: "35px",
                                        flexWrap: "nowrap",
                                        paddingTop: "30px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            disabled={isLoading || schemeLoading}
                                            variant='outlined'
                                            onClick={() => onCancel()}
                                            btnText='Cancel'
                                            boxStyle={{
                                                color: theme.palette.text.primary,
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            disabled={!formik.dirty || schemeLoading}
                                            variant='contained'
                                            isLoading={isLoading}
                                            type='submit'
                                            btnText='Save Changes'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                )
            }}


        </Formik>
    )
}

export default Lumpsum